// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type TargetAsset } from '@shared/data-access/interfaces/redux/portfolio-rebalance-state';
import { InputPercentage } from '@advisor-app/components';

interface InputWeightPercentageProps {
  ticker: string;
  asset_class?: string;
  weight: number;
  onChange: (weight: number | null) => void;
  max?: number;
  onBlur?: (obj: TargetAsset) => void;
  onKeyPress?: (event: any) => void;
  'data-testid'?: string;
  totalWeight?: number;
}

export const InputWeightPercentage = ({
  ticker,
  asset_class,
  weight,
  totalWeight,
  onChange,
  max = 100,
  onBlur,
  onKeyPress,
  'data-testid': testId = 'input',
}: InputWeightPercentageProps) => {
  return (
    <InputPercentage
      data-testid={testId}
      value={weight}
      max={max}
      step={0.5}
      onChange={onChange}
      onBlur={() => onBlur?.({ ticker, asset_class, weight })}
      onKeyPress={onKeyPress}
      precision={2}
      totalWeight={totalWeight}
    />
  );
};
